export const whitelistText = (value) => {
  // Allow only letters, numbers, spaces, and basic punctuation
  return /^[a-zA-Z0-9\s.,\-\/()#@]+$/.test(value);
};
